/**
 * Checks whether or not the browser device is using iOS
 *
 * @returns {boolean} true if browser device is using iOS
 */
export const isDeviceiOS = () =>
    ['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod'].indexOf(navigator.platform) !==
        -1 ||
    // iPad on iOS 13 detection
    (navigator.userAgent.indexOf('Mac') !== -1 && 'ontouchend' in document);

/**
 * Checks whether or not the platform is Mac
 *
 * @returns {boolean} whether the platform is Mac
 */
export const isMac = () => navigator.platform.toLowerCase().indexOf('mac') !== -1;
